export default function PHP_fscanf() {
  return (
    <div>
      <h1>PHP_fscanf</h1>
    </div>
  );
}
